export default __webpack_public_path__ + "static/media/DSU-loader-log.3e59e6d8.jpg";